export const VEW_CONTRACT_LIST = 81
export const EXPORT_CONTRACT_LIST = 82
export const DOWNLOAD_SIGNED_CONTRACT = 46
export const CREATE_CONTRACT = 35
export const VIEW_CONTRACT = 90
